import {ButtonEventListener, HoverableButton, TextureButton} from "../core/Button";
import {IPoint} from "../core/Geom";
import {Mix} from "../core/Reflection";
import {Assets} from "../data/Assets";
import {AudioChannel} from "../managers/AudioChannel";
import {Focusable} from "./Focusable";

export class Button extends Mix(TextureButton, HoverableButton(), Focusable) {

    constructor(onClick?: ButtonEventListener<Button>, texture?: PIXI.Texture | string, anchor?: IPoint) {
        super(texture, onClick, anchor);

        this.onDown.add(() => {
            AudioChannel.SFX.play(Assets.audio.buttonPress.assetName);
        });
    }
}
